import ApiService from '@/services/api';

// TYPES

/**
 * Which way the seat count moves. Carried as a direction rather than as the
 * sign of a number: a stray minus must never turn a purchase into a
 * cancellation, so each direction has its own endpoint.
 */
export type TSeatDirection = 'add' | 'cancel';

export type TChangeLicenseSeatsMaterials = {
  companyId: number;
  seats: number;
  direction: TSeatDirection;
};

export type TChangeLicenseSeatsResponse = {
  additional_seats?: number;
  cancelled_seats?: number;
};

export const seatsEndpoint = (companyId: number, direction: TSeatDirection): string =>
  direction === 'add'
    ? `/v1/companies/${companyId}/licenses/seats/`
    : `/v1/companies/${companyId}/licenses/seats/cancel/`;

export const seatsField = (direction: TSeatDirection): string =>
  direction === 'add' ? 'additional_seats' : 'cancelled_seats';

/**
 * Moves the running subscription by a few seats.
 *
 * Never a second subscription and never a full cancellation: the existing one
 * is changed, and Stripe settles the difference for the rest of the year - a
 * charge when seats are added, a credit when they are given back.
 *
 * The new capacity is not in the answer: Stripe reports it back on the webhook
 * moments later, so the overview has to be reloaded to see it.
 */
export const changeLicenseSeats = async ({
  companyId,
  seats,
  direction,
}: TChangeLicenseSeatsMaterials): Promise<TChangeLicenseSeatsResponse> => {
  const response = await ApiService.post(seatsEndpoint(companyId, direction), {
    [seatsField(direction)]: seats,
  });
  return response?.data;
};
